import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import kangarooImage from "../../assets/kangaroo/gamestep3.png";
import { ArrowRight } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import PageService from "../../services/PageService";
import { imageBaseApi } from "../../services/imageBaseApi";

const CampusHome = () => {
  const { home } = useParams();
  const [data, setData] = useState();
  const [loaded, setLoaded] = useState(false);
  const fetchData = async () => {
    try {
      const response = await PageService.getbySlug(home);
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    setLoaded(false);
    fetchData();
  }, [home]);

  // Removed useEffect for resetting loaded state on data change to prevent race conditions with cached images


  console.log(data?.featuredMedia?.url)
  return (
    <div className="main-container">
      <Row className="p-0">
        <Col lg="7" md="12" className="m-0 mt-5" >
          {/* <h1 className="font-level-1">Welcome to SmartKampus</h1> */}
          <div
            className="description-wrapper"
            dangerouslySetInnerHTML={{ __html: data?.content }}
          />
          <Link to="/courses" style={{ textDecoration: "none" }}>
            <p className="font-level-7 " style={{ cursor: "pointer" }}>
              Enter Course{" "}
              <span>
                <ArrowRight />
              </span>
            </p>
          </Link>
        </Col>
        <Col lg="1"></Col>
        <Col lg="4" md="12">
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: "#ffffffff", // white background
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >


            {data?.featuredMedia?.url && (
              <img
                src={`${imageBaseApi}${data?.featuredMedia?.url}`}
                alt=""
                loading="lazy"
                onLoad={() => {
                  console.log("Image loaded successfully:", data?.featuredMedia?.url);
                  setLoaded(true);
                }}
                onError={() => console.error("Image failed to load:", data?.featuredMedia?.url)}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CampusHome;
